import classNames from "classnames";
import React from "react";
export const FILL_COLOR_CLASS_NAMES = {
    "text-primary": "fill-text-primary dark:fill-text-primary-darkmode",
    "text-primary-inverse": "fill-text-primary-inverse dark:fill-text-primary-inverse-darkmode",
    "text-subdued": "fill-text-subdued dark:fill-text-subdued-darkmode",
    "text-disabled": "fill-text-disabled dark:fill-text-disabled-darkmode",
    "text-critical": "fill-text-critical dark:fill-text-critical-darkmode",
    "text-success": "fill-text-success dark:fill-text-success-darkmode",
    "text-link": "fill-text-link dark:fill-text-link-darkmode",
};
const DIMENSION_CLASSES = {
    xxs: "h-1 w-1",
    xs: "h-1.5 w-1.5",
    sm: "h-[14px] w-[14px]",
    md: "h-[18px] w-[18px]",
    lg: "h-3 w-3",
    xl: "h-5 w-5",
    full: "h-full w-full",
};
export const IconWrapper = ({ children, title, size, className = "", }) => {
    return React.cloneElement(children, {
        title,
        className: classNames("inline-block", className, size && DIMENSION_CLASSES[size]),
    });
};
//# sourceMappingURL=IconWrapper.js.map